/**
 * 主界面中心组件
 * 创建时间：2017-02-22
 *   创建人：zhanlz
 */
<template>	
	<div class="tabBox wrapper-content fadeInRight animated" id="homeBulletin" style="background:#fff">	
		<div class="home_box">
			<div class="home_pic">
				<img src="../../assets/project/images/picc.jpg" alt="" width="400" />
			</div>
			<div class="home_txt">欢迎进入人保救援车辆GPS平台系统</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'PageBulletin'
	};
</script>
<style scoped lang="scss">
	.home_box{ 
		margin:0 auto;
		position:relative;
		top:50%;
		transform:translateY(-50%); 
	/* 	padding-bottom: 100px;
		 display: flex !important;     
		 justify-content:center;  
		 align-items:center;     
		 flex-direction:column;*/
		 .home_pic{ 
		 	width:400px;margin:10px auto;
		 }
		 .home_txt{
		 	font-size: 20px; width: 100%; text-align: center; margin-top: 20px;
		 }
	}
</style>


// WEBPACK FOOTER //
// PageBulletin.vue?95192ea4